export default "__VITE_ASSET__BTFab2Er__"